import api from './config'

import type { LineItem } from '@/types/income'

interface MonthlyStatementParams {
  source: 'bolt' | 'uber'
  date: string
  distance_km?: number
  line_items?: LineItem[]
}

const monthlyStatementsAPI = {
  create: async (data: MonthlyStatementParams) => {
    const response = await api.post('/monthly_statements', { monthly_statement: data })
    return response.data
  }
}

export default monthlyStatementsAPI
